var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4793 41.8701C32.9843 41.8701 42.3438 32.5106 42.3438 21.0056C42.3438 9.50055 32.9843 0.141128 21.4793 0.141127C9.97425 0.141126 0.614825 9.50055 0.614824 21.0056C0.614823 32.5106 9.97425 41.8701 21.4793 41.8701ZM15.0339 19.7763L23.7274 11.0828C24.0665 10.7438 24.5116 10.5734 24.9567 10.5734C25.4018 10.5734 25.847 10.7438 26.186 11.0828C26.8658 11.7626 26.8658 12.8615 26.186 13.5413L18.7217 21.0056L26.1859 28.4699C26.8657 29.1497 26.8657 30.2485 26.1859 30.9284C25.5061 31.6082 24.4072 31.6082 23.7274 30.9284L15.0339 22.2348C14.3541 21.555 14.3541 20.4562 15.0339 19.7763Z",
    fill: "url(#paint0_linear_3285_635)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3285_635",
    x1: 21.4793,
    y1: 41.8701,
    x2: 21.4793,
    y2: 0.141127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4398FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2378DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.ad0987f5580035bdf7251873421df20d.svg";
export { ForwardRef as ReactComponent };